/**
 * Test ID utilities for Label component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for label elements
 * @param identifier - Label identifier (htmlFor, text content, or 'unnamed')
 * @returns Test ID string
 */
export const setLabelTestId = (identifier: string): string => generateTestId("Label", identifier.replace(/\s+/g, "-").toLowerCase());
